var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"current-note pa-2"},[_c('div',{staticClass:"ma-2",class:_vm.textClass},[_vm._v(_vm._s(_vm.$vuetify.lang.t(`$vuetify.note.text.${ _vm.name }`)))]),_c('div',{staticClass:"ma-2 text-right",class:_vm.textClass},[_vm._v("~ "+_vm._s(_vm.$vuetify.lang.t(`$vuetify.note.author.${ _vm.author }`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }